export default {"src":"/_next/static/media/supercell-id-black.18f01352.svg","height":29,"width":32};